import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'grupo-economico';
const route = {
  grupoEconomico: `grupo-economico/combo`,

};

@Injectable({
  providedIn: 'root'
})
export class GrupoEconomicoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar(): Observable<any> {
    return this.domainCache.getOrLoad(route.grupoEconomico, () =>
      this.apiService.get<any>(`${route.grupoEconomico}`, undefined, undefined, true)
    );
  }
}
